export default "__VITE_ASSET__5f45cdfc__"